import MicroModal from 'micromodal';

MicroModal.init();
